<div class="checks-cards-container">
  @for (check of checksArray; track $index) {
  <div
    class="check-card"
  >
    <div>
      <p class="check-number-text"></p>
      <h3 class="check-name-text">{{ check.name }}</h3>
    </div>

    <div>
      <p class="check-description-text">{{ check.description }}</p>

      <div class="buttons-container">
        <motif-button
          variant="primary"
          class="change-tab-button"
          (click)="changeToTab(check.tabNumberOrder)"
          [disabled]="check.disabled"
          [ariaLabel]="'View' + check.name + '\'s last run'"
          aria-live="polite"
        >
          View last run
        </motif-button>

        <motif-button
          variant="primary"
          class="run-check-button"
          (click)="runCheck(check.checkNumber)"
          [disabled]="isRunDisabled(check.checkNumber)"
          [ariaLabel]="'Run ' + check.name"
          aria-live="polite"
        >
          @if(check.runLoading){
          <motif-progress-bar
            [circle]="true"
            [hideLabel]="true"
            [isIndeterminate]="true"
            [tabIndex]="0"
            [ariaLabel]="'Run is loading for ' + check.name"
            aria-live="polite"
          ></motif-progress-bar>
          } @else{
          <!--  -->
          Run
          <!--  -->
          }
        </motif-button>
      </div>
    </div>

    @if(check.errorMessage){
    <div class="error-message-container">
      <motif-icon
        size="22"
        class="icon-error"
        [iconFunction]="IconoirWarningCircle"
      ></motif-icon>
      <p class="error-message">{{ check.errorMessage }}</p>
    </div>
    }
  </div>
  }
</div>

<div class="run-all-container">
  <motif-button
    variant="primary"
    [disabled]="checkForRunAllEnable()"
    (click)="checkForExistingRuns()"
    aria-label="Run All Checks"
    aria-live="polite"
  >
    Run All
  </motif-button>
</div>
